module.exports = '<svg width="38" height="32" viewBox="0 0 38 32"><path d="M0 21.011V10.989C0 10.064.806 9.6 1.706 9.6H16V.963c0-.925.79-1.238 1.53-.701l20.298 14.765c.733.538.778 1.405.048 1.942L17.502 31.737c-.733.538-1.501.224-1.501-.701v-8.637H1.707c-.899 0-1.706-.464-1.706-1.389z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-arrow-1.js
// module id = 1383
// module chunks = 14